import styled from 'styled-components'

const ViewFiAdModalStyled = styled.div`
  .viewfi-ad-modal {
    background-color: ${({ theme }) => theme.color.neutral};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
    padding: 24px;
    position: relative;
    width: 840px;
    max-width: 90vw;
    height: 640px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;

    .close-btn {
      top: 10px;
      right: 10px;
      background-color: ${({ theme }) => theme.color.transparent};
      border: none;
      z-index: 10;
    }

    .race-name-container {
      margin-bottom: 2px;
      text-align: center;

      .race-name {
        font-size: 24px;
        line-height: 20px;
      }
    }
  }
`

export default ViewFiAdModalStyled
